export function initInputModality(): void {
    const root = document.documentElement;

    function setMouse(): void {
        root.classList.add('using-mouse');
    }

    function setKeyboard(event: KeyboardEvent): void {
        if (event.key === 'Tab') {
            root.classList.remove('using-mouse');
        }
    }

    document.addEventListener('mousedown', setMouse);
    document.addEventListener('keydown', setKeyboard);
}
